/**
 * Template Versions log — frontend API client (Vahid 2026-07-21).
 *
 * Read-only view over the per-report TEMPLATE version registry + change
 * history (backend/src/report/templateChangelog.ts). Admin-only endpoint;
 * the /admin/template-versions section is inside the admin-gated area.
 */

import apiClient from './apiClient';

export interface TemplateChangeAuthor {
  name: string;
  kind: 'ai' | 'human';
  detail?: string;
}

export interface TemplateReportSummary {
  key: string;
  name: string;
  version: string | null;
  lastChanged: string | null;
  lastAppliedBy: TemplateChangeAuthor | null;
}

export interface TemplateChangeEntry {
  reportKey: string;
  reportName: string;
  version: string;
  date: string;
  appliedBy: TemplateChangeAuthor;
  requestedBy?: string;
  context?: string;
  changes: string[];
}

export interface TemplateVersionLog {
  reports: TemplateReportSummary[];
  history: TemplateChangeEntry[];
}

export async function fetchTemplateVersionLog(): Promise<TemplateVersionLog> {
  const { data } = await apiClient.get<TemplateVersionLog>('/report-templates/versions-log');
  return data;
}
